import { render, staticRenderFns } from "./SavedSearchesCard.vue?vue&type=template&id=ab822946&scoped=true&"
import script from "./SavedSearchesCard.vue?vue&type=script&lang=js&"
export * from "./SavedSearchesCard.vue?vue&type=script&lang=js&"
import style0 from "./SavedSearchesCard.vue?vue&type=style&index=0&id=ab822946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab822946",
  null
  
)

export default component.exports